import { put, putResolve, select, takeLatest } from 'typed-redux-saga/macro';
import { editSavingsPlan, getAutosaveActivities, getPotsAccount, getSavingsPlan, updateSavingRulesFailure, } from '../actions';
import { UPDATE_SAVING_RULES } from '../actions/types';
function* updateSavingRulesWorker(action) {
    try {
        const { savingsPlanId, rules } = action.payload;
        const response = yield* putResolve(editSavingsPlan(savingsPlanId, { rules, isPaused: false }, true));
        if (response.payload.savingsPlan) {
            const modifiedResponse = { ...response, extra: { ...response.extra, skipSet: false } };
            yield* put(modifiedResponse);
        }
        else {
            throw new Error('Api failure');
        }
    }
    catch {
        yield* put(updateSavingRulesFailure());
        yield* putResolve(getPotsAccount());
    }
}
function* getAutosaveActivitiesWorker(action) {
    if (!action.extra.skipSet) {
        yield* put(getAutosaveActivities({
            page: 1,
            perPage: 30,
        }));
    }
}
function* getAutosaveAccountWorker(action) {
    if (action.payload?.account?.status === 'ACTIVE') {
        yield* put(getSavingsPlan());
    }
}
function* getAutosaveAccountWithoutCheckWorker() {
    yield* put(getSavingsPlan());
}
function* prefetchAutosaveActivitiesWorker(action) {
    if (action.payload.savingsPlan) {
        const autoSaveActivities = yield* select((state) => state.unpersistedPotsReducer.autoSaveActivities);
        if (!autoSaveActivities?.length) {
            yield* put(getAutosaveActivities({
                page: 1,
                perPage: 30,
            }));
        }
    }
}
function* autosaveSagas() {
    yield* takeLatest(UPDATE_SAVING_RULES, updateSavingRulesWorker);
    yield* takeLatest('GET_POTS_ACCOUNT_SUCCESS', getAutosaveAccountWorker);
    yield* takeLatest('ACCEPT_AUTOSAVE_MANDATE_SUCCESS', getAutosaveAccountWithoutCheckWorker);
    yield* takeLatest('EDIT_SAVINGS_PLAN_SUCCESS', getAutosaveActivitiesWorker);
    yield* takeLatest('GET_SAVINGS_PLAN_SUCCESS', prefetchAutosaveActivitiesWorker);
}
export default autosaveSagas;
